// extracted by mini-css-extract-plugin
module.exports = {"root":"PosClinicFilter_root__3UoZG"};